import axios from 'axios'
import Qs from 'qs';
import Vue from 'vue'
import route from '../router/index.js'
export default {
  config: {
    baseUrl: '/api/v1/', //接口地址部分，不要域名
    baseUrl2: '/api/',
    imgUrl: 'http://phwsp.hansa.hansacloud.cn/',
    header: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
	  'token':'MDAwMDAwMDAwMICydG4'
    },
  },
  request(options = {}) {
    options.data = options.data || {}
    if (localStorage.getItem('share_id')) options.data.sid = localStorage.getItem('share_id')
    if (localStorage.getItem('share_key')) options.data.skey = localStorage.getItem('share_key')
    options.url = options.url.indexOf('http') > -1 ? options.url : options.nv1 ? this.config.baseUrl2 + options.url :
      this.config.baseUrl + options.url;
    options.method = options.method
    options.method == 'GET' ? options.params = options.data : options.data = Qs.stringify(options.data)
    let token = {
      'token': localStorage.getItem('token') || ''
    }
    options.headers = Object.assign(this.config.header, token)
    return new Promise((resolve, reject) => {
      axios.request(options).then(e => {
        if (options.pass) {
          resolve(e.data)
        } else if (e.data.code == 1) {
          resolve(e.data.data)
        } else if (e.data.code == -2) {
          route.replace('/agent/evpi')
        } else if (e.data.msg) {
          Vue.prototype.$layer.msg(e.data.msg)
        }
      });
    });
  },
  get(url, data, options) {
    if (!options) {
      options = {}
    }
    options.url = url
    options.data = data
    options.method = 'GET'
    return this.request(options)
  },
  post(url, data, options) {
    if (!options) {
      options = {}
    }
    options.url = url
    options.data = data
    options.method = 'POST'
    return this.request(options)
  },
}



// WEBPACK FOOTER //
// ./src/assets/http.js